'use strict';

const urlJoin = require('url-join');
const { default: stipulate, buildOptions, resolveUrl } = require('stipulate');
const { baseOptions } = require('./configuration');
const config = require('../config');

const verifyConfirmationToken = (options, query) => {
  if (!options.token) {
    throw new Error('Expected `options.token` to be set');
  }

  const { baseUrl } = config.get();
  let url = urlJoin(baseUrl, '/pb/verify-token/');
  url = resolveUrl(url, query);

  const body = {
    token_id: options.token,
  };

  const requestOptions = buildOptions(baseOptions, {
    method: 'POST',
    body: JSON.stringify(body),
  });

  return stipulate(url, requestOptions, 'blob');
};

module.exports = verifyConfirmationToken;
